<template>
  <div>
    <v-container class="programa-page" fluid>
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
      >

      <v-sheet class="programa-hero" rounded elevation="2">
        <div>
          <p class="hero-kicker">Ficha del programa</p>
          <h2 class="hero-title-text">
            {{ programa.nombre_compuesto || 'Nuevo programa' }}
          </h2>
          <p class="hero-subtitle" v-if="programa.programa_id">
            ID {{ programa.programa_id }} · Versión {{ programa.version || '-' }} · Grupo {{ programa.grupo || '-' }}
          </p>
        </div>
        <div class="hero-chips">
          <v-chip v-if="programa.estado" small label color="deep-purple accent-4" dark>{{ programa.estado }}</v-chip>
          <v-chip v-if="programa.gestion" small outlined color="white">Gestión {{ programa.gestion }}</v-chip>
          <v-chip v-if="programa.sede_id" small outlined color="white">Sede {{ programa.sede_id }}</v-chip>
          <v-btn small color="success" :loading="loading" :disabled="loading" outlined @click="guardarcambios">
            Guardar cambios
          </v-btn>
        </div>
      </v-sheet>

      <v-card :loading="loading" class="programa-card">
        <!-- <v-card-title v-if="programa && programa.nombre_compuesto" class="text-center primary--text">
          <v-spacer></v-spacer>
          {{ `${programa.nombre_compuesto.slice(0, 1)}-${programa.programa_id}   ${programa.nombre_compuesto}` }}
          <v-spacer></v-spacer>
        </v-card-title> -->
        <v-card-text class="programa-body">
          <form>
            <div class="section-card">
              <p class="bg-primary mb-0 pa-1 section-title pl-5">
                Informacion del programa:
                <a class="btn btn-default section-toggle" data-toggle="collapse" href="#collapseinfor"> expandir </a>
              </p>
              <div class="collapse in section-body" id="collapseinfor">
              <v-card outlined class="mb-3">
                <v-card-text class="pa-3 d-flex flex-wrap justify-end align-center">
                  <div class="d-flex align-center mx-2">
                    <v-icon color="deep-purple accent-4" class="mr-2">mdi-information-outline</v-icon>
                    <div>
                      <div class="text-caption grey--text text--darken-1 mb-1">Estado del Programa</div>
                      <v-chip
                        v-if="programa.estado"
                        small
                        color="deep-purple accent-4"
                        dark
                        label
                        class="font-weight-medium">
                        {{ programa.estado }}
                      </v-chip>
                      <v-chip v-else small outlined color="grey" label>
                        <v-icon left x-small>mdi-help-circle</v-icon>
                        Sin estado
                      </v-chip>
                    </div>
                  </div>

                  <div class="d-flex align-center mx-2">
                    <v-icon color="blue darken-2" class="mr-2">mdi-calendar-clock</v-icon>
                    <div>
                      <div class="text-caption grey--text text--darken-1 mb-1">Fecha de Registro</div>
                      <v-chip
                        v-if="programa.fecha_registro"
                        small
                        color="blue darken-2"
                        dark
                        label
                        class="font-weight-medium">
                        {{ programa.fecha_registro }}
                      </v-chip>
                      <v-chip v-else small outlined color="grey" label>
                        <v-icon left x-small>mdi-calendar-remove</v-icon>
                        Sin fecha
                      </v-chip>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <v-row dense class="mb-2">
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model.trim="programa.nombre_compuesto"
                    label="* Nombre compuesto"
                    :readonly="only_read_acade"
                    placeholder="Ingrese el nombre compuesto..."
                    dense
                    outlined
                    hide-details />
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="programa.nombre_corto"
                    :readonly="only_read_acade"
                    label="* Nombre corto"
                    placeholder="Máximo 60 caracteres"
                    dense
                    outlined
                    counter="60"
                    maxlength="60"
                    hide-details />
                </v-col>
              </v-row>

              <v-row dense class="mb-2">
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model.trim="programa.fecha_matricula"
                    :readonly="only_read_acade"
                    type="date"
                    label="* Fecha inicio de matriculaciones"
                    dense
                    outlined
                    hide-details />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model.trim="programa.fecha_inicio"
                    :readonly="only_read_acade"
                    type="date"
                    label="* Fecha inicio del programa"
                    dense
                    outlined
                    hide-details />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model.trim="programa.fecha_fin"
                    :readonly="only_read_acade"
                    type="date"
                    label="Fecha fin del programa"
                    dense
                    outlined
                    hide-details />
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model.number="programa.gestion"
                    :readonly="only_read_acade"
                    type="number"
                    label="* Gestión del programa"
                    placeholder="Ej: 2024"
                    dense
                    outlined
                    hide-details />
                </v-col>
              </v-row>

              <v-row dense class="mb-2">

                <v-col cols="12" sm="4" md="6">
                  <v-select
                    v-model="programa.sede_id"
                    :items="sedes_filtradas"
                    :readonly="only_read_acade"
                    item-text="nombre"
                    item-value="id"
                    label="* Sede del programa"
                    dense
                    outlined
                    hide-details />
                </v-col>

                <v-col cols="12" sm="4" md="3">
                  <v-select
                    v-model.trim="programa.modalidad"
                    :readonly="only_read_acade"
                    :items="[
                      { text: 'Presencial', value: 'P' },
                      { text: 'Virtual', value: 'V' },
                      { text: 'Semipresencial', value: 'S' }
                    ]"
                    label="* Modalidad"
                    dense
                    outlined
                    hide-details />
                </v-col>
                <v-col cols="12" sm="2" md="1">
                  <v-text-field
                    v-model.number="programa.version"
                    :readonly="only_read_acade"
                    type="number"
                    label="* Versión"
                    placeholder="Ej: 1"
                    dense
                    outlined
                    hide-details />
                </v-col>

                <v-col cols="12" sm="2" md="1">
                  <v-text-field
                    v-model.number="programa.grupo"
                    :readonly="only_read_acade"
                    type="number"
                    label="* Grupo"
                    placeholder="Ej: 1"
                    dense
                    outlined
                    hide-details />
                </v-col>

                <v-col cols="12" sm="2" md="1">
                  <v-text-field
                    v-model.number="programa.nota_aprobacion"
                    :readonly="only_read_acade"
                    type="number"
                    label="* Nota mínima de aprobación"
                    placeholder="Ej: 71"
                    dense
                    outlined
                    hide-details />
                </v-col>

              </v-row>
<!-- 
              <v-row dense class="mb-2">
              </v-row> -->

              <v-row dense class="mb-4">
                <v-col cols="12" md="6">
                  <Usuarios :current="false" :model="coordinadorsel" :xdefault="programa.coordinador.coordinador_id" :readonly="only_read_acade" />
                  <label class="caption grey--text ml-1">Coordinador de marketing</label>
                </v-col>
                <v-col cols="12" md="6">
                  <Usuarios :current="false" :model="responsablesel" :xdefault="programa.responsable.responsable_id" :readonly="only_read_acade" />
                  <label class="caption grey--text ml-1">Responsable Academico</label>
                </v-col>
              </v-row>

              <v-divider class="my-4" />

              <v-select
                v-if="$store.state.CARGO.sede.unidad_negocio != 1"
                :items="convenios"
                v-model="universidadsel"
                item-text="nombre"
                item-value="id"
                label="Universidad/Certificación"
                outlined
                dense
                placeholder="Seleccione..."
                hide-details
                return-object
                class="mb-3"
                style="max-width: 500px" />

              <v-alert v-if="universidadsel && universidadsel.id" type="info" dense text class="mb-2">
                <strong>Convenio:</strong> ({{ universidadsel.abreviatura }}) {{ universidadsel.nombre }}
              </v-alert>
              <v-alert dense text type="info" class="mb-2">
                <strong>Unidad de negocio:</strong> {{ UNIDAD_NEGOCIO_ID }}
              </v-alert>

              <v-divider class="my-2" />

              <v-card outlined class="mb-4">
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="auto">
                      <v-icon color="purple">mdi-information</v-icon>
                    </v-col>
                    <v-col>
                      <span class="font-weight-medium">Si el programa es de beneficiencia sin fines de lucro, active esta opción:</span>
                    </v-col>
                    <v-col cols="12" sm="auto">
                      <v-switch
                        v-model="programa.is_campania"
                        label="Curso de beneficiencia"
                        :readonly="!is_perm_benefi"
                        color="purple"
                        hide-details
                        class="mt-0" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
 
              <v-progress-linear v-if="loadingproy" indeterminate color="primary" class="mb-4" />
              
              <v-card v-if="proyectoasig" outlined class="mb-4">
                <v-card-title class="green white--text py-2">
                  <v-icon left color="white">mdi-check-circle</v-icon>
                  Proyecto Asignado
                </v-card-title>
                <v-card-text class="pt-3">
                  <v-row dense>
                    <v-col cols="12" sm="6" md="4">
                      <div class="text-caption grey--text">Código</div>
                      <div class="font-weight-medium">{{ proyectoasig.codigo }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="8">
                      <div class="text-caption grey--text">Proyecto</div>
                      <div class="font-weight-medium">{{ proyectoasig.programa }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text">Gestión</div>
                      <div>{{ proyectoasig.gestion }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text">Versión</div>
                      <div>{{ proyectoasig.version }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div class="text-caption grey--text">Área</div>
                      <div>{{ proyectoasig.area }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="text-caption grey--text">Fecha inicio</div>
                      <div>{{ proyectoasig.fecha_inicio }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="text-caption grey--text">Fecha culminación</div>
                      <div>{{ proyectoasig.fecha_culminacion }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <div class="text-caption grey--text">Estado</div>
                      <v-chip small color="success" text-color="white">{{ proyectoasig.estado_programa }}</v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-divider class="my-4" />

              <v-row>
                <v-col cols="12" md="6">
                  <v-card outlined>
                    <v-card-title class="py-3 primary white--text">
                      <v-icon left style="color: white !important;">mdi-image</v-icon>
                      Portada del Programa
                      <v-chip x-small color="error" class="ml-2">Requerido</v-chip>
                    </v-card-title>
                    <v-card-text class="text-center pa-4">
                      <v-file-input
                        ref="imagenportada"
                        v-model="archivoPortada"
                        accept="image/*"
                        :disabled="cargandoportada || only_read_acade"
                        label="Seleccione un archivo de portada"
                        prepend-icon="mdi-camera"
                        dense
                        outlined
                        hide-details
                        @change="imagenselect(1)"
                        class="mb-3" />
                      
                      <v-btn
                        :disabled="portadasel || only_read_acade"
                        :loading="cargandoportada"
                        color="primary"
                        small
                        @click="subirimagen(1)">
                        <v-icon left small>mdi-upload</v-icon>
                        Subir Imagen
                      </v-btn>
                      
                      <v-alert v-if="subidores" dense text type="success" class="mt-3">
                        Imagen subida correctamente
                      </v-alert>

                      <v-img
                        v-if="programa.portada"
                        :src="location_programa_portadas + programa.portada"
                        alt="PORTADA"
                        class="mt-3"
                        max-height="300"
                        contain />
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card outlined>
                    <v-card-title class="py-3 secondary white--text">
                      <v-icon left color="white">mdi-certificate</v-icon>
                      Certificado del Programa
                    </v-card-title>
                    <v-card-text class="text-center pa-4">
                      <v-file-input
                        ref="imagencertificado"
                        v-model="archivoCertificado"
                        accept="image/*"
                        :disabled="cargandocertificado || only_read_acade"
                        label="Seleccione el fondo del certificado"
                        prepend-icon="mdi-camera"
                        dense
                        outlined
                        hide-details
                        @change="imagenselect(2)"
                        class="mb-3" />
                      
                      <v-btn
                        :disabled="certificadosel || only_read_acade"
                        :loading="cargandocertificado"
                        color="secondary"
                        small
                        @click="subirimagen(2)">
                        <v-icon left small>mdi-upload</v-icon>
                        Subir Imagen
                      </v-btn>
                      
                      <v-alert v-if="subidores1" dense text type="success" class="mt-3">
                        Imagen subida correctamente
                      </v-alert>

                      <v-img
                        v-if="programa.arte"
                        :src="location_certificado_programa + programa.arte"
                        alt="CERTIFICADO"
                        class="mt-3"
                        max-height="300"
                        contain />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
                </div>
              </div>

              <div class="section-card">
                <p class="bg-primary mb-0 mt-3 pa-1 section-title pl-5">
                  Modulos del programa:
                  <a class="btn btn-default section-toggle" data-toggle="collapse" href="#collapsemodulos"> expandir </a>
                </p>
                <div class="collapse section-body" id="collapsemodulos">
                 
            <!-- <v-card 
                v-if="moduloEditandoCopia">
              <v-card-text class="pa-3">
                <v-row dense align="center">
                  <v-col cols="auto" class="drag-handle">
                    <v-icon color="grey darken-1">mdi-drag-vertical</v-icon>
                  </v-col>
                  
                  <v-col cols="12" sm="1" class="text-center">
                    <v-chip 
                      small 
                      color="primary" 
                      text-color="white" 
                      label 
                      class="font-weight-bold">
                      {{ moduloEditandoCopia.numero }}
                    </v-chip>
                  </v-col>
                  
                  <v-col cols="12" sm="4">
                    <AModulos 
                      :model="moduloEditandoCopia" 
                      :zdefault="moduloEditandoCopia" 
                      :disabled="(moduloEditando !== (moduloEditandoCopia.programa_modulo_id || moduloEditandoCopia._tempId)) || only_read_acade" />
                  </v-col>
                  
                  <v-col cols="12" sm="2">
                    <v-text-field
                      v-model.trim="moduloEditandoCopia.fecha_inicio"
                      :readonly="moduloEditando !== (moduloEditandoCopia.programa_modulo_id || moduloEditandoCopia._tempId)"
                      :disabled="only_read_acade"
                      type="date"
                      label="Fecha inicio"
                      dense
                      outlined
                      hide-details />
                  </v-col>
                  
                  <v-col cols="12" sm="2">
                    <v-text-field
                      v-model.trim="moduloEditandoCopia.fecha_fin"
                      :readonly="moduloEditando !== (moduloEditandoCopia.programa_modulo_id || moduloEditandoCopia._tempId)"
                      :disabled="only_read_acade"
                      type="date"
                      label="Fecha fin"
                      dense
                      outlined
                      hide-details />
                  </v-col>
                  <v-col cols="12" sm="2" class="text-center">
                      <v-btn 
                        color="success" 
                        x-small
                        dark
                        icon
                        @click="guardarModulo(moduloEditandoCopia)">
                        <v-icon small>mdi-check</v-icon>
                      </v-btn>
                      <v-btn 
                        color="error" 
                        x-small
                        dark
                        icon
                        @click="cancelarEdicion()">
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card> -->
              <template  >
                <v-card 
                  v-for="(m) in programa.programa_modulo" 
                  :key="m.programa_modulo_id"
                  v-show="!moduloEditando || moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)"
                  class="modulo-item-card mb-4"
                  draggable="true"
                  @dragstart="handleDragStart(m)"
                  @dragover.prevent="handleDragOver()"
                  @drop="handleDrop(m)"
                  @dragend="handleDragEnd"
                  :class="{ 'dragging': draggedProgramaModulo === m }"
                  :elevation="draggedProgramaModulo === m ? 0 : 3"
                  shaped>
                  <v-card-text class="pa-3">
                    <v-row dense align="center" >
                      <v-col cols="auto" class="drag-handle">
                        <v-icon color="grey darken-1">mdi-drag-vertical</v-icon>
                      </v-col>
                      <v-col cols="12" sm="1" style="position: relative; z-index: 99;" 
                      v-if="programa.programa_modulo.length ===1
                      && ((moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade)">
                        <v-select
                          v-if="(moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade"
                          v-model="m.numero"
                          :items="[
                            { text: '0', value: '0' },
                            { text: '1', value: '1' }]"
                          item-text="text"
                          item-value="value"
                          :readonly="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)"
                          :disabled="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade"
                          label="Número"
                          dense
                          outlined
                          hide-details />
                          <span v-if="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade">
                            {{ m?.tipo_calificacion? m.tipo_calificacion.replace(/_/g," ") : 'No tiene' }}
                          </span>
                      </v-col>
                      <v-col cols="12" sm="1" class="text-center" >
                        <v-chip 
                          small 
                          color="primary" 
                          text-color="white" 
                          label 
                          class="font-weight-bold">
                          {{ m.numero }}
                        </v-chip>
                      </v-col>
                      
                      <v-col cols="12" sm="3" style="position: relative; z-index: 100;">
                        <AModulos 
                          :model="m" 
                          :zdefault="m" 
                          :disabled="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade" />
                      </v-col>
                      
                      <v-col cols="12" sm="2" style="position: relative; z-index: 99;">
                        <v-select
                          v-if="(moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade"
                          v-model="m.tipo_calificacion"
                          :items="tiposCalificacion"
                          item-text="text"
                          item-value="value"
                          :readonly="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)"
                          :disabled="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade"
                          label="Tipo calificación"
                          dense
                          outlined
                          hide-details />
                          <span v-if="(moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)) || only_read_acade">
                            {{ m?.tipo_calificacion? m.tipo_calificacion.replace(/_/g," ") : 'No tiene' }}
                          </span>
                      </v-col>
                      
                      <v-col cols="12" sm="2">
                        <v-text-field
                          v-model.trim="m.fecha_inicio"
                          :readonly="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)"
                          :disabled="only_read_acade"
                          type="date"
                          label="Fecha inicio"
                          dense
                          outlined
                          hide-details />
                      </v-col>
                      
                      <v-col cols="12" sm="2">
                        <v-text-field
                          v-model.trim="m.fecha_fin"
                          :readonly="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)"
                          :disabled="only_read_acade"
                          type="date"
                          label="Fecha fin"
                          dense
                          outlined
                          hide-details />
                      </v-col>
                      
                      
                      <v-col cols="12" sm="1" class="text-center" >
                        <div v-if="moduloEditando === (m.programa_modulo_id || m._tempId || m.numero)">
                          <v-btn 
                            color="success" 
                            x-small
                            dark
                            icon
                            @click="guardarModulo(m)">
                            <v-icon style="color: #28A745 !important;" small>mdi-check</v-icon>
                          </v-btn>
                          <v-btn 
                            color="error" 
                            x-small
                            dark
                            icon
                            @click="cancelarEdicion()">
                            <v-icon style="color: red !important;"  small>mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <div v-else>
                          <v-btn 
                            color="blue" 
                            :disabled="only_read_acade"
                            x-small
                            dark
                            icon
                            @click="editarModulo(m)">
                            <v-icon style="color: #FFB300 !important;" small>mdi-pencil</v-icon>
                          </v-btn>
                        </div>
                        <v-tooltip bottom  v-if="moduloEditando !== (m.programa_modulo_id || m._tempId || m.numero)">
                          <template #activator="{ on, attrs }">
                            <v-btn 
                              color="orange" 
                              v-bind="attrs" 
                              v-on="on" 
                              :disabled="only_read_acade" 
                              small 
                              dark 
                              icon
                              @click="openeditmod(m)">
                              <v-icon small style="color: #FFB300 !important;"> mdi-pencil-box </v-icon>
                            </v-btn>
                          </template>
                          <span>Editar módulo completo</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template> 

              <div class="mt-4 d-flex gap-2" v-if="!moduloEditando">
                <v-btn 
                  :disabled="only_read_acade" 
                  color="error" 
                  outlined
                  small
                  @click="addnewmodulo(0)">
                  <v-icon small left>mdi-minus</v-icon>
                  Quitar módulo
                </v-btn>
                <v-btn 
                  :disabled="only_read_acade" 
                  color="success" 
                  outlined
                  small
                  @click="addnewmodulo(1)">
                  <v-icon small left>mdi-plus</v-icon>
                  Agregar módulo
                </v-btn>
              </div>

              <a
                class="btn btn-link btn-sm"
                style="margin-left: 84px"
                role="button"
                data-toggle="collapse"
                href="#collapseExamplem"
                aria-expanded="false"
                aria-controls="collapseExample">
                <span class="glyphicon glyphicon-chevron-down"></span> Crear Nuevo Modulo si No existe (opcional)
              </a>
              </div>

              <div class="collapse" id="collapseExamplem">
                <NewModulo />
              </div>
            </div> 

            <div class="section-card">
            <v-row class="bg-primary mb-0 mt-3 pa-0 section-title" no-gutters>
              <v-col cols="6" sm="3" class="pt-4 pl-5">
                Planes de cobros:
                <a class="btn btn-default" data-toggle="collapse" href="#collapseplanes"> expandir </a>
              </v-col>
              <v-col cols="6" sm="9"> 
                <v-combobox
                  v-model="templatexsel"
                  :items="templates"
                  :loading="loadingtemplates"
                  :disabled="only_read_conta"
                  item-text="nombre"
                  color="#1e3a8a"
                  autofocus
                  label="Agregar plan de pagos predefinido"
                  class="ma-4"
                  hide-details
                  dark
                  dense
                  outlined />
              </v-col>
            </v-row>
            <div class="collapse section-body" id="collapseplanes">
              <div v-if="programa.planes && programa.planes.length > 0">
                <v-alert type="info" outlined class="mt-4 ml-2 mr-2">
                  <p class="my-0">
                    <b>AVISO:</b> No puede crear nuevos planes, debe solicitar a la nacional la creacion de un nuevo
                    plan y use la opcion de agregar plan de pagos predefinido, ahi edite los montos y cantidad de cuotas
                    por cada concepto predefinido.
                  </p>
                  <small class="red--text"> Use punto decimal para valores fraccionados, maximo 2 decimales. </small>
                </v-alert>
              </div>

              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <!-- ******************************************************************************************************************************** -->
              <div class="row pb-0 mr-2 ml-1" v-for="(c, ind) in programa.planes" :key="ind + '--'">
                <div class="col bg-info"> 
                  <input
                    type="text"
                    :disabled="c.xedit == false"
                    v-model.trim="c.nombre" 
                    class="form-control"
                    placeholder="nombre..." />
                  <label class="">
                    <small> <span class="text-danger">*</span> Nombre del plan </small></label
                  >
                </div>
                <div v-if="c.plan_cobro_programa_id" class="col col-sm-1 col-lg-1 text-center bg-info">
                  <input
                    type="checkbox"
                    v-model="c.estado"
                    :disabled="only_read_conta"
                    class="form-control"
                    placeholder="estado..."
                    style="height: 1.6em" />
                  <label class=""> <small> estado </small></label>
                </div>

                <div v-if="c.plan_cobro_programa_id" class="col col-sm-3 col-lg-2 bg-info">
                  <input
                    type="datetime"
                    v-model.trim="c.fecha_registro"
                    disabled
                    class="form-control"
                    placeholder="fecha_registro..." />
                  <label class="">
                    <small> <span class="text-danger">*</span> Fecha registro del plan </small></label
                  >
                </div>

                <div v-if="c.aprobado" class="col col-sm-2 col-lg-1 text-center bg-info">
                  <input
                    type="checkbox"
                    v-model="c.aprobado"
                    :disabled="true"
                    class="form-control"
                    placeholder="aprobado..."
                    style="height: 1.6em" />
                  <label class=""> <small> Aprobado </small></label>
                </div>

                <div v-else-if="c.plan_cobro_programa_id" class="col col-sm-2 col-lg-2 text-center bg-info">
                  <v-btn v-if="$store.state.CARGO.id==14" small color="red" dark @click="aprobarplan(c)">Aprobar Plan</v-btn>
                  <span v-else>Nac. conta. aprueba</span>
                </div>

                <div class="col col-sm-12" v-if="c.estado">
                  <div class="row" v-for="(co, indd) in c.cobros" :key="indd">
                    <div
                      v-if="c.plan_cobro_programa_id"
                      class="col col-lg-6 col-sm-4 col-sm-offset-2 col-lg-offset-2"
                      style="padding-top: 0; padding-bottom: 0">
                      <v-text-field
                        dense
                        outlined
                        label="* Nombre del concepto:"
                        v-model.trim="co.nombre"
                        :readonly="c.plan_cobro_programa_id ? true : false"></v-text-field>
                    </div>

                    <div
                      v-else
                      class="col col-lg-6 col-sm-4 col-sm-offset-2 col-lg-offset-2"
                      style="padding-top: 0; padding-bottom: 0"> 
                      <select v-model.number="co.concepto_pago_id" class="form-control" :disabled="co.xedit == false">
                        <option v-for="(cnp, indcpt) in conceptos" :key="indcpt" :value="cnp.id">
                          {{ cnp.nombre }}
                        </option>
                      </select>
                      <label class="">
                        <small> <span class="text-danger">*</span> Seleccione el concepto </small></label
                      >
                    </div>

                    <div class="col col-sm-3 col-lg-2" style="margin: 0 !important; padding-top: 0; padding-bottom: 0">
                      <v-text-field
                        dense
                        outlined
                        label="* Monto"
                        type="number"
                        v-model.number="co.monto"
                        @keyup="redondearTwoDecimals(co, 'monto')"
                        :readonly="c.plan_cobro_programa_id ? true : false"></v-text-field>
                    </div>

                    <div class="col col-sm-2 col-lg-2" style="margin: 0 !important; padding-top: 0; padding-bottom: 0">
                      <v-text-field
                        dense
                        outlined
                        label="* Cuotas"
                        type="number"
                        v-model.number="co.cuotas"
                        :readonly="c.plan_cobro_programa_id ? true : false"></v-text-field>
                    </div>

                    <div
                      v-if="false"
                      class="col col-sm-1 col-lg-1"
                      style="margin: 0 !important; padding-top: 0; padding-bottom: 0">
                      <input
                        type="checkbox"
                        v-model="co.estado"
                        :disabled="c.plan_cobro_programa_id ? true : false"
                        class="form-control"
                        placeholder="estado..."
                        style="height: 1.6em" />
                      <label class="">
                        <small> <span class="text-danger">*</span> estado </small></label
                      >
                    </div>
                  </div>

                  <div class="text-right" v-if="!c.plan_cobro_programa_id && c.xedit != false">
                    <button type="button" class="btn btn-sm btn-warning white--text" @click="addnewconcepto(0, c)">
                      - quitar concepto
                    </button>
                    <button type="button" class="btn btn-sm btn-success white--text" @click="addnewconcepto(1, c)">
                      + agregar concepto
                    </button>
                  </div>
                </div>
                <div class="col col-sm-12 pt-0 pl-0 pr-0" v-else>
                  <p class="text-center bg-danger text-danger mb-12 mt-0 pt-0">
                    Este plan tiene el estado desactivado, los conceptos de este plan no estan disponibles, no se pueden
                    registrar inscritos a este plan.
                  </p>
                </div>
                
                <div class="col col-sm-12 ma-0 pa-0">
                  <hr />
                </div>
              </div>

              <div>
                <button
                  v-if="programa.planes && programa.planes.length > 0"
                  type="button"
                  :disabled="only_read_conta"
                  class="btn btn-sm btn-danger white--text"
                  @click="addnewplan(0)">
                  - quitar plan
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-success white--text"
                  v-if="$store.state.DATA_USER.id == 14 || $store.state.CARGO.id == 100"
                  @click="addnewplan(1)">
                  + agregar plan
                </button>
                <div v-else>
                  <v-alert type="info" outlined>
                    <p class="my-0">
                      <b>AVISO:</b> No puede crear nuevos planes, debe solicitar a la nacional la creacion de un nuevo
                      plan y use la opcion de agregar plan de pagos predefinido, ahi edite los montos y cantidad de
                      cuotas por cada concepto predefinido.
                    </p>
                  </v-alert>
                </div>
              </div>
            </div>
            </div>

            <p v-if="!programa.programa_id" class="grey mb-8 mt-14 pa-1 section-title">
              <b>NOTA:</b> Para definir los titulos intermedios primero debe crear el programa y luego ir a editar el
              programa creado, las certificaciones intermedias son usados para la generacion de certificados.
            </p>

            <div v-if="programa.programa_id" class="section-card">
              <p class="bg-primary mb-0 mt-3 pa-1 section-title pl-5">
                Definir Titulos Intermedios:
                <a class="btn btn-default section-toggle" data-toggle="collapse" href="#collapsepostitulos"> expandir </a>
              </p>
              <div class="collapse section-body" id="collapsepostitulos">
                <p class="text-center blue--text mb-1">
                  Al definir certificaciones los programas tendran la opcion de seleccionar con cual certificado seran
                  generados.
                </p>
                <v-progress-linear indeterminate class="mt-0 mb-4" v-if="loadingpostitulos" />

                <v-row no-gutters v-if="postitulos.length">
                  <v-col cols="8" offset-sm="1" class="mb-6">
                    <Universidades :model="postitulouni" v-bind:convenio="true" :xdefault="postitulodefaultuniv" />
                    <label class="green--text ml-1">Seleccione la Universidad de certificacion</label>
                  </v-col>
                </v-row>

                <div v-for="(po, indx) in postitulos" :key="indx">
                  <v-row no-gutters>
                    <v-col cols="8" offset-sm="1">
                      <v-text-field
                        v-model.trim="po.postitulo"
                        label="* Titulo de certificacion:"
                        placeholder="max 200 caracteres..."
                        :prefix="'' + (indx + 1)"
                        class="mb-4"
                        hide-details
                        outlined
                        dense></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        v-model.number="po.horas_academicas"
                        type="number"
                        label="* Carga Horaria:"
                        placeholder="0......999"
                        prefix="Horas:"
                        class="mb-4"
                        style="margin-left: 0.2em"
                        hide-details
                        outlined
                        dense></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <button
                  type="button"
                  :disabled="!ispostgrado || only_read_acade"
                  class="btn btn-sm btn-success white--text ml-4"
                  @click="addnewpostitulo(true)">
                  + agregar certificacion
                </button>
                <button
                  type="button"
                  :disabled="!ispostgrado || only_read_acade"
                  class="btn btn-sm btn-danger white--text"
                  @click="addnewpostitulo(false)">
                  - quitar certificacion
                </button>
                <hr class="mb-8 mt-1 blue" />
              </div>
            </div>

            <div class="section-card row pt-2 mb-4">
              <div class="col col-sm-4 col-lg-3">
                <input
                  type="text"
                  v-model.trim="codigo_contabilidad"
                  cdisabled="only_read_conta"
                  class="form-control"
                  placeholder="codigo contabilidad..."
                  style="height: 1.9em" />
                <label class="">
                  <small> <span class="text-danger">*</span> codigo de contabilidad </small></label
                >
              </div>
              <div class="col">
                <v-btn small :disabled="only_read_conta" color="primary" tile @click="guardarcodigoconta()">Guardar codigo de contabilidad </v-btn>
              </div>

              <div class="col" v-if="($store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 1)">
                <v-btn small :disabled="only_read_conta || yaenviado_loading" color="orange" dark tile @click="openModalNetsuiteConta()" :loading="yaenviado_loading"> Agregar a Netsuite </v-btn>
              </div>
            </div>
          </form>
            <div class="section-card">
            <v-form ref="vform" v-model="formValid" lazy-validation>
            <div v-if="matriz">{{ matriz.direccion }} {{ matriz.ciudad }}</div>
            <v-row>
              <v-col cols="8"> 
                <v-select
                  :rules="fieldRules"
                  v-model="sucursal"
                  :items="sucursales"
                  :disabled="only_read_conta"
                  item-text="text_nit"
                  outlined
                  dense
                  label="Sucursal de Programa para la factura"
                  return-object
                  messages="Para emision de recibo y factura debe seleccionar la sucursal.">
                </v-select>
              </v-col>
              <v-col cols="4">
                <v-btn color="primary" :disabled="only_read_conta" tile @click="saveFormSucursal"> Guardar/ Asignar Sucursal </v-btn>
              </v-col>
            </v-row> 
          </v-form>
          </div>
        </v-card-text>
        <v-card-title v-if="programa && programa.nombre_compuesto" class="text-center primary--text">
          <v-spacer></v-spacer>
          {{ `${programa.nombre_compuesto.slice(0, 1)}-${programa.programa_id}   ${programa.nombre_compuesto}` }}
          <v-spacer></v-spacer>
        </v-card-title>

        <div class="d-flex justify-center" v-if="universidadsel && universidadsel.id">
          <p class="blue--text text-center">
            Convenio:
            <b>({{ universidadsel.abreviatura }}) {{ universidadsel.nombre }}</b>
          </p>
          <v-btn v-if="UNIDAD_NEGOCIO_ID != 1" @click="universidadsel = null" x-small tile text color="red" outlined>
            Quitar convenio
          </v-btn>
        </div>
        <p class="text-center text-danger font-weight-bold">{{ msg }}</p>
        <v-card-actions class="text-center">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="guardarcambios()">Guardar cambios</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>

    <VerProyectos ref="verproyectos" v-on:proyectosel="asignarprogramaunsxx" />
    <NetSuiteConta ref="refNetSuiteConta"/>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import Usuarios from '@/components/AUsuariosActivos';
  import Universidades from '@/components/AUniversidades.vue';
  import AModulos from '@/components/ASelecionar-modulo';
  import NewModulo from '@/components/AModulosCrear';
  import { getheadersrest, parseModalidad } from '@/components/Utils';
  import VerProyectos from '@/views/sigloxx/verproyectos.vue';
  import xaxios from '@/xaxios';
  import { mapState } from 'vuex';
  import NetSuiteConta from '../components/Programa-viewrestNetsuiteConta.vue';
  import ProgramaService from '@/views/pagos/services/programa.service'
  import ProgramaUniversidadService from '@/views/pagos/services/programa-universidad.service'
  import {informar} from './programa_created'

  export default {
    data() {
      return {
        location_certificado_programa: process.env.VUE_APP_URL_CERT_PROGRAMAS,
        location_programa_portadas: process.env.VUE_APP_URL_PORTADAS,
        // api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
        api_rest: process.env.VUE_APP_API_REST,
        loadingtemplates: false,
        loading: false,
        cargandoportada: false,
        cargandocertificado: false,
        loadingpostitulos: false,
        cargandores1: false,
        cargandores: false,
        ispostgrado: false,
        subidores: false,
        subidores1: false,
        portadasel: true,
        certificadosel: true,
        archivoPortada: null,
        archivoCertificado: null,
        modulos_obligatorios: false,
        is_perm_benefi: false,
        isdevmode: false,
        msg: '',
        matriz: '',
        conceptos: [],
        convenios: [],
        templates: [],
        templatexsel: [],
        sedes: [],
        coordinadorsel: { idusuario: null },
        responsablesel: { idusuario: null },
        universidadsel: { iduniversidad: null },
        programa: { coordinador: {}, responsable: {}, programa_modulo: [], planes: [] },
        codigo_contabilidad: '',
        formValid: true,
        fieldRules: [(v) => !!v || 'Campo Obligatorio'],
        postitulodefaultuniv: null,
        sucursal: null,
        sucursales: [],
        postitulos: [],
        postitulouni: { iduniversidad: null },
        proyectosxx: null,
        loadingproy: false,
        proyectoasig: null,
        nomostrarproy: true, 
        only_read_acade: false,
        only_read_conta: false,
        visibleDialogo: false,
        programasUniversidades: [],
        programaSeleccionado: {
          universidadId: null,
          programaUniversidadId: null,
          programaUniversidad: null,
        },
        actualizandoPrograma: false,
        busqueda: null,
        retardo: null,
        confirmacion: {
          titulo: 'Establecer Programa Universidad',
          mensaje: '¿Está seguro de establecer el programa con la universidad seleccionada? Esta acción no se puede deshacer.',
          realizandoAccion: false,
          fnAceptar: () => {  
            this.actualizarPrograma()
          }
        },
        yaenviado: [],
        yaenviado_loading: false,
        xposgradin: {},
        // Ejemplo de drag and drop
        ejemploItems: [
          { id: 1, nombre: 'Item 1', descripcion: 'Descripción del item 1' },
          { id: 2, nombre: 'Item 2', descripcion: 'Descripción del item 2' },
          { id: 3, nombre: 'Item 3', descripcion: 'Descripción del item 3' },
          { id: 4, nombre: 'Item 4', descripcion: 'Descripción del item 4' },
          { id: 5, nombre: 'Item 5', descripcion: 'Descripción del item 5' }
        ],
        draggedItemIndex: null,
        draggedProgramaModulo: null,
        moduloEditando: null,
        moduloEditandoCopia: null,
        // Enum para tipos de Moodle
        tiposCalificacion: [
          { value: 'Moodle', text: 'Moodle' },
          { value: 'Sistema', text: 'Sistema' },
          { value: 'Moodle y Sistema', text: 'Moodle y Sistema' }
        ],
        tipoMoodleSeleccionado: null
      };
    },
    components: { Usuarios, Universidades, AModulos, NewModulo, VerProyectos, NetSuiteConta },
    watch: {
      UNIDAD_NEGOCIO_ID() {
        this.getconceptosdepago();
      },
      // 'universidadsel.iduniversidad': function() {
      'universidadsel.id': function () {
        //if (!this.universidadsel.iduniversidad) {
        if (this.UNIDAD_NEGOCIO_ID == 1) {
          // esam
          if (!this.universidadsel || !this.universidadsel.id) {
            this.proyectosxx = null;
            this.nomostrarproy = false;
            return;
          }
        }

        //modo editar programa
        if (this.programa.universidad_id && this.nomostrarproy) {
          return;
        }
        //descomentar esto para proyectos
        /*let id = this.universidadsel.iduniversidad.id;
      let idsigloxx = 9;
      if( id == idsigloxx ){
        this.$refs.verproyectos.openmodal();
      }*/
        //window.console.log('>>>>>>>>>>>>>>>', this.universidadsel);
      },
      '$store.state.convenio': function () {
        //window.console.log('>>>>>>>>>>>>>>>UUU', this.universidadsel);
        this.universidadsel = this.$store.state.convenio;
      },
      templatexsel: function () {
        // window.console.log("templatexsel",this.templatexsel);

        let plan = {
          tipo_plan_id: this.templatexsel.tipo_plan_id,
          aprobado: false,
          estado: true,
          nombre: this.templatexsel.nombre,
          xedit: false,
          cobros: [],
        };
        this.templatexsel.conceptos.forEach((x) => {
          plan.cobros.push({
            concepto_pago_id: x.concepto_pago_id,
            monto: 0,
            cuotas: x.max_cuotas,
            xedit: false,
            xmax_cuotas: x.max_cuotas,
          });
        });
        let existe = false;
        if (!this.programa.planes) this.programa.planes = [];
        this.programa.planes.forEach((x) => {
          if (x.nombre == plan.nombre) existe = true;
        });
        if (!existe) {
          this.programa.planes.push(plan);
          window.$('#collapseplanes').collapse('show');
        }
      },
    },
    computed: {
      ...mapState({
        // programa: (state) => state.programa.value,
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
        /*sedes: (state) => {
          if (state.UNIDAD_NEGOCIO_ID) {
            return state.modsede.items.filter((item) => item.unidad_negocio == state.UNIDAD_NEGOCIO_ID);
          }
          return [];
        },*/
      }),
      ispermitidoeditmod: function () {
        if (this.programa && !this.programa.programa_id) return false;
        let cargo = this.$store.state.CARGO.id;
        // 5,6,7,17,20,23
        return (
          cargo == 1 ||
          cargo == 5 ||
          cargo == 6 ||
          cargo == 7 ||
          cargo == 8 ||
          cargo == 17 ||
          cargo == 20 ||
          cargo == 23
        );
      },
      sedes_filtradas(){
        let unidad = this.xposgradin.unidad_negocio_id;
        if(!unidad) {
          unidad = this.$store.state.CARGO.sede.unidad_negocio; 
        }
        /* else{ 
          // ya no se usa daba error al crear el programa desaparece :()
          delete this.programa.sede_id
        } */
        const filtradas = this.sedes.filter((item) => item.unidad_negocio == unidad); 
        // window.console.log('unidad',unidad, this.programa);
        
        // return this.sedes
        return filtradas
      }
    },
    methods: { 
      moduloKey(item, index) {
        return item.programa_modulo_id || item.modulo_id || item.numero || `tmp-${index}`;
      },
      reordenarModulos() {
        if (!this.programa.programa_modulo) return;
        this.programa.programa_modulo.forEach((m, idx) => {
          m.numero = idx
        });
      },
      getprogramabyid(id) {
        //window.console.log('>>>>>JEJEJEJE',id);
        this.loading = true;
        // this.getproyectoasignado(id);
        xaxios
          .get(`${this.api_rest}/esam/programa/id/${id}`)
          .then(async ({ data }) => {
            //window.console.log('PROGRMA GET:::', data);
            this.loading = false;
            if (!data.responsable) data.responsable = {};
            if (!data.coordinador) data.coordinador = {};
            data.modalidad = parseModalidad(data.modalidad);

            if (!data.programa_modulo) data.programa_modulo = [];
            data.programa_modulo.sort((a, b) => {
              let f = 0;
              if (a.numero > b.numero) f = 1;
              else if (a.numero < b.numero) f = -1;
              return f;
            });

            // data.map((x=>{
            //   x.fecha_matricula = data.fecha_matricula
            // }))
            // window.console.log('-----', data);
            this.programa = data;
            // window.console.log('-----', this.programa);
            if(data.categoria_id > 0){
              this.programa.course_category_id = data.categoria_id;
            }
            this.codigo_contabilidad = data.codigo;
            this.getSucursales(await this.getNits(), this.programa.sede_id, data.sucursal_id ? data.sucursal_id : null);

            let ex = this.convenios.find((x) => x.id == data.universidad_id);
            if (ex) this.universidadsel = ex;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      getNits() {
        const qs = gql`query{ ${''} getNits{ id, nombre, descripcion, nro, estado }}`;
        return this.$apollo.query({ query: qs }).then(({ data }) => (data.getNits ? data.getNits : []));
      },
      async getSucursales(nits, sede_id, sucursal_id) {
        //const qs = gql`query{ ${''} getSucursales{ id,nit_id,direccion,telefono,ciudad,numero_sucursal,sede_id } }`;
        const qs = gql`query{ ${''} getSucursalesByIdSede(id:${sede_id}) { id,nit_id,direccion,telefono,ciudad,numero_sucursal } }`;
        // window.console.log('sucursal_id:', sucursal_id);
        this.$apollo.query({ query: qs }).then(({ data }) => {
          if (!data.getSucursalesByIdSede) data.getSucursalesByIdSede = [];
          if (data.getSucursalesByIdSede.length) {
            // window.console.log('data.getSucursalesByIdSede',data.getSucursalesByIdSede,sucursal_id);

            data.getSucursalesByIdSede.map((suc) => {
              suc.nit = nits.find((nit) => nit.id == suc.nit_id);
              suc.text_nit = `${suc.nit.nro} -  ${suc.nit.nombre} [${suc.direccion}]`;
              return suc;
            });
            //this.sucursales = data.getSucursalesByIdSede.filter((suc) => suc.sede_id == sede_id);
            this.sucursales = data.getSucursalesByIdSede;
            // window.console.log('this.sucursales',this.sucursales);
            if (sucursal_id) {
              this.sucursal = this.sucursales.find((item) => item.id == sucursal_id);
              this.matriz = this.sucursales.find((item) => item.id == sucursal_id);
              //this.matriz = data.getSucursalesByIdSede.find((s) => s.numero_sucursal === 0 && s.nit.nro == this.sucursal.nit.nro);
            }
          }
        });
      },
      async getsucs() {
        let idsede = this.$store.state.CARGO.sede.id;
        this.getSucursales2(await this.getNits(), idsede);
      },
      async getSedes() {
        const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio, direccion, telefono1, telefono2, telefono_fijo, latitud, longitud, modelo_recibo, aulas {id}, ciudad{ id, nombre, departamento {nombre}}}}`;
        let getSedes = await this.$apollo.query({ query: qs })
          .then(({ data: { getSedes } }) => getSedes).catch(() => []);

        const idcargo = this.$store.state.CARGO.id;
        if(idcargo != 1 ){
          const negocios = [];
          this.$store.state.CARGOS.forEach(x=>negocios.push(x.sede.id));
          const uniqueArray = [...new Set(negocios)]; 
          getSedes = getSedes.filter((item) => {
            return uniqueArray.includes(item.id);
          });

        }else{
          getSedes = getSedes.filter((item) => item.unidad_negocio == this.$store.state.UNIDAD_NEGOCIO_ID);
        }

        this.sedes = getSedes.length ? getSedes:[] 
      },
      async getSucursales2(nits, sede_id) {
        const qs = gql`query{ ${''} getSucursalesByIdSede(id:${sede_id}) { id,nit_id,direccion,telefono,ciudad,numero_sucursal } }`;
        //window.console.log('JEJEJEJE:', qs);
        this.$apollo.query({ query: qs }).then(({ data }) => {
          if (!data.getSucursalesByIdSede) data.getSucursalesByIdSede = [];
          // window.console.log('LOG:::getSucursalesByIdSede', data.getSucursalesByIdSede);
          data.getSucursalesByIdSede.map((suc) => {
            suc.nit = nits.find((nit) => nit.id == suc.nit_id);
            suc.text_nit = `${suc.nit.nro} -  ${suc.nit.nombre}`;
            return suc;
          });
          this.sucursales = data.getSucursalesByIdSede;
        });
      },
      async saveFormSucursal() {
        if (this.$refs.vform.validate()) {
          if (await this.$root.$confirm.open('Guardar Sucursal', 'Estas seguro?', { color: 'red' })) {
            const url = `${this.api_rest}/api/esam/programa/sucursal/insertar`;
            const formData = { programa_id: this.programa.programa_id, sucursal_id: this.sucursal.id };
            xaxios.post(url, formData).then(() => {
              this.$root.$notify.show(`Sucursal Asignado correctamente`, { color: 'success' });
            });
          }
        }
      },
      addnewpostitulo(isadd) {
        if (isadd) {
          let idp = this.programa.programa_id;
          this.postitulos.push({ id: 0, postitulo: '', programa_id: idp, horas_academicas: null });
        } else {
          this.postitulos.pop();
        }
      },
      addnewmodulo(flag) {
        if (!this.programa.programa_modulo) this.programa.programa_modulo = [];
        //let ultimo = this.programa.programa_modulo[ this.programa.programa_modulo.length - 1 ];
        const modulos=this.programa.programa_modulo.map(x=>x.numero);
         //window.console.log('modulos:::', modulos, 'num:::', num);
        if (flag) {
          //if( ultimo && ultimo.numero ) num = ultimo.numero;
         const cantidadNull = this.programa.programa_modulo
            .filter(x => x.programa_modulo_id < 0)
            .length;
          // const modulosNegativos = this.programa.programa_modulo.filter(x => x.programa_modulo_id < 0);
          const numeroMaximo = modulos.length > 0 
            ? Math.max(...modulos.filter(x=>x!=null))
            : -1;
          const programa_modulo_id=  -1*(cantidadNull)-1;
          this.programa.programa_modulo.push({ modulo_id: null,programa_modulo_id: programa_modulo_id, numero: numeroMaximo+1 });
          this.editarModulo( this.programa.programa_modulo[this.programa.programa_modulo.length - 1]);
        } else {
          /*if( !ultimo.modulo_id ) */ this.programa.programa_modulo.pop();
        }
      },
      addnewplan(flag) {
        if (!this.programa.planes) this.programa.planes = [];
        if (flag) {
          this.programa.planes.push({ aprobado: false, estado: true, nombre: '', cobros: [] });
        } else {
          let ultimo = this.programa.planes[this.programa.planes.length - 1];
          if (ultimo && !ultimo.plan_cobro_programa_id) this.programa.planes.pop();
        }
      },
      addnewconcepto(flag, plan) {
        if (flag) {
          plan.cobros.push({ concepto_pago_id: 0, monto: 0, cuotas: 1 });
        } else {
          plan.cobros.pop();
        }
      },
      planesPordefecto() {
        this.loadingtemplates = true;
        let vue = this;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let sedeid = this.$store.state.CARGO.sede.id
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/templates/planpagos?unidadnegocio=${unidad}&activo=true`,
          headers: {},
        };

        // window.console.log('config:::::???');
        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            window.console.log('templates>> ', data);
            let newdata = data.filter(item=>item.id!==-30 && item.id !==29);
            if( unidad == 15 && sedeid == 82 ){
              newdata = data.filter(item=>!item.nombre.includes('BOLIVIA'));
            }else if(unidad == 15){
              newdata = data.filter(item=>item.nombre.includes('BOLIVIA'));
            }
            vue.templates = newdata;
            //vue.templates = data;
            // window.console.log('templates>> ', data);
            vue.loadingtemplates = false;
          })
          .catch(function (error) { 
            window.console.log(error);
            vue.loadingtemplates = false;
          });
      },
      imagenselect(flag) {
        if (flag == 1) {
          this.portadasel = !this.archivoPortada;
          this.subidores = false;
        } else if (flag == 2) {
          this.certificadosel = !this.archivoCertificado;
          this.subidores1 = false;
        }
      },
      subirimagen(flag) {
        let date = new Date().getTime();
        let formData = new FormData();
        const vue = this;
        let photo;
        let url;
        if (flag == 1) {
          if (!this.archivoPortada) {
            return;
          }
          this.cargandoportada = true;
          this.subidores = false;
          window.console.log('archivoPortada:::', this.archivoPortada);
          photo = this.archivoPortada;
          formData.append('file', photo);
          formData.append('nombre', 'portada-' + date + '.jpg');
          url = `${process.env.VUE_APP_URL_WEBDATA}portada_upload.php`;
        } else if (flag == 2) {
          if (!this.archivoCertificado) {
            return;
          }
          this.cargandocertificado = true;
          this.subidores1 = false;
          photo = this.archivoCertificado;
          formData.append('file', photo);
          formData.append('nombre', 'certificado-' + date + '.jpg');
          url = `${process.env.VUE_APP_URL_WEBDATA}certificado_upload.php`;
        }
        //let myHeaders = getheadersrest(); // NO ACEPTA EL TOKEN EN PRODUCTION
        var myHeaders = new Headers();
        window.console.log('photo:::', photo);
        fetch(url, { method: 'POST', headers: myHeaders, body: formData })
          .then((response) => response.json())
          .then((result) => {
            if (flag == 1) {
              vue.cargandoportada = false;
              if (result.status) {
                vue.subidores = true;
                vue.programa.portada = result.newCertName;
              }
            } else if (flag == 2) {
              vue.cargandocertificado = false;
              if (result.status) {
                vue.subidores1 = true;
                vue.programa.arte = result.newCertName;
              }
            }
          })
          .catch(() => {});
      },
      getconceptosdepago() {
        var vue = this;
        xaxios
          .post(`${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`, {
            unidad_negocio_id: this.UNIDAD_NEGOCIO_ID,
          })
          .then(({ data }) => {
            vue.conceptos = data.filter(
              (concepto) => concepto.unidad_negocio_id == this.UNIDAD_NEGOCIO_ID && concepto.opcional === false,
            );
            // window.console.log(JSON.stringify(data));
          })
          .catch(() => {});
      },
      validar_fechas_modulos(){
        const mods = this.programa.programa_modulo.filter(m=>!m.fecha_inicio || !m.fecha_fin)
        // window.console.log('modulos sin fechas:::', mods);
        if( !mods || mods.length > 0 ) {
          return false
        }
        return true
      },
      guardarcambios() {
        // TODO en prod habilitar para obligar
        /* const vs = this.validar_fechas_modulos()
        if(!vs) {
          this.$root.$notify.show(`Error: hay modulos sin fechas de inicio, todos los modulos deben tener fechas`, {color:'red',x: 'right',});
          return
        } */

        //demo
        //this.senddatapostitulos();
        // TODO
        //window.console.log('loG:::', this.programa.fecha_matricula);
        //window.console.log('loG:::', this.programa.fecha_inicio);
        let date1 = new Date(this.programa.fecha_matricula + 'T00:00:00-04:00');
        let date2 = new Date(this.programa.fecha_inicio + 'T00:00:00-04:00');
        let diff = date2.getTime() - date1.getTime();
        //window.console.log('loG:::', diff);
        if (diff < 0) {
          this.msg = 'La fecha de matriculacion debe ser menor a la fecha de inicio del programa.';
          return;
        }
        let unidad_negocio_id = this.UNIDAD_NEGOCIO_ID;
        this.msg = '';
        const vue = this;
        const newplanes = [];
        const oldplanes = [];
        let ob = window.Object.assign({}, this.programa);
        let hss = [];
        hss.push(ob);
        let obj = hss.pop();
        if (!obj.sede_id) {
          this.msg = 'Seleccione la sede';
          return;
        }
        // if (!this.universidadsel.iduniversidad) {
        if (unidad_negocio_id == 1 || unidad_negocio_id == 10) {
          // esam
          if (!this.universidadsel || !this.universidadsel.id) {
            this.msg = 'Debe seleccionar la universidad/institucion de certificacion.';
            return;
          }
        }

        if (this.modulos_obligatorios && obj.programa_modulo.length == 0) {
          this.msg = 'Esta categoria de postgrado requiere los modulos obligatoriamente.';
          return;
        }
        if(this.modulos_obligatorios){ 
          if ((this.programa.xcategoria_id == 1 || this.programa.xcategoria_id == 24) && obj.programa_modulo.length < 5) {
            this.msg = 'Registre todos los modulos del programa, el diplomado debe tener al menos 5 modulos';
            return;
          }

          if ((this.programa.xcategoria_id == 2 || this.programa.xcategoria_id == 25) && obj.programa_modulo.length < 7) {
            this.msg = 'Registre todos los modulos del programa, la Especialidad debe tener al menos 7 modulos';
            return;
          }

          if ((this.programa.xcategoria_id == 3 || this.programa.xcategoria_id == 26) && obj.programa_modulo.length < 10) {
            this.msg = 'Registre todos los modulos del programa, la Maestría debe tener al menos 10 modulos';
            return;
          }
        }
        if (!this.programa.modalidad) {
          this.msg = 'Seleccione la modalidad';
          return;
        }
        if (this.isdevmode && !obj.portada) {
          obj.portada = 'sinfotoentest.jpg';
        }
        if (!obj.portada) {
          this.msg = 'Seleccione y suba la portada';
          return;
        }

        if (!obj.nombre_corto) {
          this.msg = 'Ingrese el nombre corto del programa, no mayor a 60 caracteres';
          return;
        }
        if (obj.nombre_corto.length > 60) {
          this.msg = 'El nombre corto no puede ser mayor a 60 caracteres';
          return;
        }
        if (!obj.fecha_matricula) {
          this.msg = 'Debe ingresar la fecha de matriculacion del programa';
          return;
        }

        if (this.sucursal) {
          obj.sucursal_id = this.sucursal.id; // aunque mande esto, no se guardar
          // hay que usar el boton por separada asignar sucursal
        }

        this.loading = true;
        let valido = true;
        if (!obj.planes) obj.planes = [];
        if (obj.fecha_matricula) {
          let fs = obj.fecha_matricula.split('-');
          obj.fecha_matricula = fs[2] + '/' + fs[1] + '/' + fs[0];
        }
        if (obj.fecha_inicio) {
          let fs = obj.fecha_inicio.split('-');
          obj.fecha_inicio = fs[2] + '/' + fs[1] + '/' + fs[0];
        }
        if (obj.fecha_fin) {
          let fs = obj.fecha_fin.split('-');
          obj.fecha_fin = fs[2] + '/' + fs[1] + '/' + fs[0];
        }
        if (!obj.nombre_compuesto.endsWith(')')) {
          let uni = 'U';
          if (this.universidadsel) uni = 'U' + this.universidadsel.id;
          obj.nombre_compuesto += ` (V${obj.version} G${obj.grupo} ${obj.gestion} S${obj.sede_id} ${uni})`;
        }
        obj.programa_modulo=obj.programa_modulo.map(m=>{
          if(m.programa_modulo_id<0){
            return window.Object.assign({}, m, {programa_modulo_id: null})
          }
          return m;
        })
        obj.planes.forEach(function (e) {
          if (!e.plan_cobro_programa_id) {
            newplanes.push(e);
            e.cobros.forEach(function (c) {
              //c.concepto_pago_id = c.concepto_id;
              //window.console.log('>>>>>>>>>>> COBROSSS::::', c);

              if (c.concepto_pago_id == 1 && c.monto > 1500) {
                //window.console.log( 'CCC',c )
                valido = false;
                vue.loading = false;
                vue.msg = 'La matricula no puede exceder el monto de 1500 bs.';
              }

              if (!c.monto || c.monto < 0) {
                window.console.log('MONTO:::', c, e);
                valido = false;
                vue.loading = false;
                vue.msg = `Monto (${c.monto}) invalido en ${e.nombre}`;
              }

              if (c.xmax_cuotas && c.xmax_cuotas < c.cuotas) {
                valido = false;
                vue.loading = false;
                vue.msg = `Numero de cuotas (${c.cuotas}) No debe superar el maximo pre definido ${c.xmax_cuotas}`;
              }
            });
          } else {
            e.cobros.forEach(function (c) {
              c.concepto_pago_id = c.concepto_id;
              /* window.console.log('>>>>>>>>>>> COBROSSS::::', e);

            if( c.concepto_id == 1 && c.monto > 1500 ){
              //window.console.log( 'CCC',c )
              valido = false;
              vue.loading = false;
              vue.msg = "La matricula no puede exceder el monto de 1500 bs.";
            } */
              delete c.cobro_programa_id;
              delete c.fecha_registro;
              delete c.estado;
            });
            oldplanes.push(e);
          }
        });
        if (!valido) return;
        //descomentar para produccion version 06.62
        let duplicados = this.toFindDuplicates(this.postitulos);
        if (duplicados) {
          this.msg = duplicados;
          return;
        }

        if (unidad_negocio_id == 1) {
          // esam
          if (!this.universidadsel.id) {
            this.msg = 'Seleccione la universidad de convenio';
            return;
          }
        }

        // descomentar esto en produccion para proyectos
        /*if( this.universidadsel.iduniversidad && this.universidadsel.iduniversidad.id == 9 ){
       let idaprobado = 2;
       if( !this.proyectosxx ){
         this.msg = "Cuando seleccione la universidad de certificacion igual a la Siglo XX, debe especificar el proyecto correspondiente aprobado por el responsable DNA.";
         return;
       }else if(this.proyectosxx.estado_programa!=idaprobado){
         this.msg = `El proyecto seleccionado (${this.proyectosxx.text}) no esta aprobado por el responsable DNA.`;
         return;
       }
     }*/
        var addmodulos = [];
        var modmodulos = [];
        if (obj.programa_modulo) {
          obj.programa_modulo.forEach(function (e) {
            if (e.fecha_inicio && e.fecha_inicio.includes('-')) {
              let fs = e.fecha_inicio.split('-');
              e.fecha_inicio = fs[2] + '/' + fs[1] + '/' + fs[0];
            } else if (!e.fecha_inicio) delete e.fecha_inicio;

            if (e.fecha_fin && e.fecha_fin.includes('-')) {
              let fs = e.fecha_fin.split('-');
              e.fecha_fin = fs[2] + '/' + fs[1] + '/' + fs[0];
            } else if (!e.fecha_fin) delete e.fecha_fin;
            if(e.docente){
              e.docente_id = e.docente.docente_id;
            }
            delete e.nombre;
            delete e.estado;
            delete e.puntuacion;
            delete e.fecha_primera_instancia;
            delete e.fecha_segunda_instancia;
            //if( e.modulo_id == 1848 ) e.estado = 0;
            // e.estado = 1; //TODO quitar esto en producion
            // if( e.programa_modulo_id == 12085 ) e.estado = 0;//quitar esto en producion
            e.programa_modulo_id=e.programa_modulo_id<0?null:e.programa_modulo_id;
            const modulo=window.Object.assign({}, e,{numero: Number(e.numero) || 0});
            if (e.programa_modulo_id) modmodulos.push(modulo);
            else addmodulos.push(modulo);
          });
        }

        
        obj.modificar_planes = oldplanes;
        //obj.modulos = obj.programa_modulo;
        obj.modulos = addmodulos;
        obj.modificar_modulos = modmodulos;
        delete obj.planes;
        obj.planes = newplanes;
        //obj.modalidad = '';
        if (obj.programa_id) delete obj.programa_modulo;
        if (!obj.arte) delete obj.arte;
        if (!obj.fecha_matricula) delete obj.fecha_matricula;
        if (!obj.fecha_inicio) delete obj.fecha_inicio;
        if (!obj.fecha_fin) delete obj.fecha_fin;
        if (!obj.universidad_id) delete obj.universidad_id;
        if (!obj.plataforma_id) delete obj.plataforma_id;
        if (!obj.coordinador.coordinador_id) delete obj.coordinador;
        if (!obj.responsable.responsable_id) delete obj.responsable;
        if (this.coordinadorsel.idusuario) obj.coordinador = { coordinador_id: this.coordinadorsel.idusuario.id };
        if (this.responsablesel.idusuario) obj.responsable = { responsable_id: this.responsablesel.idusuario.id };
        // if (this.universidadsel.iduniversidad) obj.universidad_id = this.universidadsel.iduniversidad.id;
        if (this.universidadsel && this.universidadsel.id) obj.universidad_id = this.universidadsel.id;
        else obj.universidad_id = null;

        let metodo = 'POST';
        if (obj.programa_id) {
          metodo = 'PUT';
          //delete obj.modulos; //agrega nuevos modulos cambiar a  modificar_modulos
        }
        window.console.log('obj a enviar:::', obj);

        //window.console.log('obj >>> ', obj);

        const opt = {
          okText: 'Continuar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        const message2 = {
          title: 'Confirmacion.',
          body: 'Si no esta seguro puede cancelar',
        };

        
        this.$dialog
          .confirm(message2, opt)
          .then(function (dialog) {
            vue.senddatapostitulos();
            vue.senddatoscreateupdate(dialog, obj, metodo);
          })
          .catch(function () {
            vue.loading = false;
          });
      },
      
      toFindDuplicates(arry) {
        const vue = this;
        let repetidos = [];
        let repetido = false;
        let vacio = false;
        let sinhoras = false;
        let demasiado = false;
        let universidad = false;
        arry.forEach((x) => {
          universidad = true;
          if (vue.postitulouni.iduniversidad) {
            x.universidad = vue.postitulouni.iduniversidad.id;
          }
          if (!x.postitulo) x.postitulo = '';
          let ex = repetidos.find((r) => r == x.postitulo);
          if (!x.postitulo) vacio = true;
          if (!x.horas_academicas) sinhoras = true;
          else if (x.postitulo.length > 200) demasiado = true;
          if (ex) {
            repetido = true;
            return;
          } else {
            repetidos.push(x.postitulo);
          }
        });
        if (repetido) return 'Las certificaciones no pueden estar repetidos.';
        if (vacio) return 'Los titulos de certificaciones no pueden estar vacios.';
        if (sinhoras) return 'Las certificaciones deben estar con sus respectivas horas mayor a 0.';
        if (demasiado) return 'Los titulos de certificaciones no pueden exceder los 200 caracteres.';
        if (universidad && !this.postitulouni.iduniversidad)
          return 'Seleccione la universidad de certificaciones intermedias';
        return null;
      },
      // Métodos para Drag and Drop de módulos
      handleDragStart(programaModulo) {
        window.console.log('Drag started on index:', programaModulo);
        this.draggedProgramaModulo = programaModulo;
      },
      handleDragOver() {
      },
      handleDrop(programaModulo) {
        if (this.draggedProgramaModulo === null || this.draggedProgramaModulo === programaModulo) return;
        
        const programa_modulo=this.programa.programa_modulo.map((m) => {
          if(m === programaModulo){
            window.console.log('>>> swap ', m.numero, ' con ', this.draggedProgramaModulo.numero);
            return { ...m, numero: this.draggedProgramaModulo.numero};
          }else if(m=== this.draggedProgramaModulo){
            return { ...m, numero: programaModulo.numero };
          }
          return { ...m }
          
      });
      this.programa.programa_modulo=[]
      
      this.programa.programa_modulo=programa_modulo.sort((a, b) => a.numero - b.numero)
        this.$root.$notify.show('Módulos reordenados. No olvides guardar los cambios.', { color: 'info' });
      },
      handleDragEnd() {
        this.draggedProgramaModulo = null;
      },
      editarModulo(modulo) {
        window.console.log('modulo a editar:::', modulo);
        // Guardar copia del módulo por si se cancela
        this.moduloEditandoCopia = modulo;
        window.console.log('modulo a editar:::', this.moduloEditandoCopia);
        // Usar programa_modulo_id si existe, sino usar modulo_id, sino generar uno temporal
        this.moduloEditando = modulo.programa_modulo_id || modulo.modulo_id || modulo.numero || `temp_${Date.now()}` ;
        if (!modulo.programa_modulo_id && !modulo._tempId) {
          modulo._tempId = this.moduloEditando;
        }
      },
      guardarModulo(modulo) {
        // Aquí podrías validar los datos antes de guardar
        window.console.log('Guardando módulo:::', modulo);
        if (!modulo.modulo_id) {
          this.$root.$notify.show('Debe seleccionar un módulo', { color: 'error' });
          return;
        }
        if (!modulo.tipo_calificacion) {
          this.$root.$notify.show('Tiene que seleccionar un tipo de calificación', { color: 'error' });
          return;
        }
         this.programa.programa_modulo= this.programa.programa_modulo.map((m) => {
          if (m.programa_modulo_id === modulo.programa_modulo_id ) {
            return { ...modulo };
          }
          return m;
        });
        this.moduloEditando = null;
        this.moduloEditandoCopia = null;
        this.$root.$notify.show('Módulo actualizado. No olvides guardar los cambios del programa.', { color: 'success' });
      },
      cancelarEdicion() {
        // Restaurar los datos originales
        if (this.moduloEditandoCopia) {
          const index = this.programa.programa_modulo.findIndex(
            m => m.programa_modulo_id === this.moduloEditandoCopia.programa_modulo_id
          );
          if (index !== -1) {
            this.$set(this.programa.programa_modulo, index, this.moduloEditandoCopia);
          }
        }
        this.moduloEditando = null;
        this.moduloEditandoCopia = null;
      },
      senddatapostitulos() {
        xaxios
          .post(`${this.api_rest}/api/v1/postitulos/asignar`, this.postitulos)
          //axios.post(`http://localhost:8090/api/v1/postitulos/asignar`,this.postitulos)
          .then(function (response) {
            let data = response.data;
            window.console.log(data);
          })
          .catch(function (error) {
            window.console.log(error);
          });
      },
      getpostitulos(programa_id) {
        this.loadingpostitulos = true;
        const vue = this;
        xaxios
          .get(`${this.api_rest}/api/v1/postitulos/programaid/${programa_id}`)
          .then(function (response) {
            let data = response.data;
            //window.console.log('>>> ', data);
            data.data.forEach((x) => {
              vue.postitulodefaultuniv = x.Universidad;
              vue.postitulos.push({
                id: x.Id,
                programa_id: x.Programa_id,
                postitulo: x.Postitulo,
                horas_academicas: x.Horas_academicas,
                universidad: null,
              });
            });
            vue.loadingpostitulos = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingpostitulos = false;
          });
      },
      senddatoscreateupdate(dialog, obj, metodo) {
        const vue = this;
        dialog.close();
        let myHeaders = getheadersrest();
        var raw = JSON.stringify(obj, null, 4);
        var requestOptions = { method: metodo, headers: myHeaders, body: raw };
        //window.console.log( '\n\n\n',raw,'\n\n\n' );

        fetch(`${this.api_rest}/esam/programa`, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            window.console.log('RESSSS;', result);
            //vue.msg = result.data;
            if (typeof result == 'string') {
              vue.msg = result;
            } else if (result.data) {
              vue.msg = result.data;
              // vue.rerportTG(obj.portada, obj.nombre_compuesto);
            } else if (typeof result == 'object') {
              if (result.programa_id) {
                if (this.proyectosxx) {
                  vue.msg = `Programa creado(${result.programa_id}), asignando proyecto...`;
                  vue.asignarprogramaunsxx2(result.programa_id);
                } else {
                  vue.msg =
                    'Programa registrado exitosamente, vaya al menu programas para ver el programa, ID:' +
                    result.programa_id +
                    ', sin proyecto unsxx asignado.';
                  
                    //window.console.log('obj:::', obj);
                    if(metodo == 'POST'){
                      vue.rerportTG(obj.portada, obj.nombre_compuesto,result.programa_id);
                    }
                }
              } else {
                vue.msg = result.error;
              }
            } else {
              vue.msg = result.error;
            }
            vue.loading = false;
          })
          .catch(() => {
            vue.loading = false;
          });
      },
      rerportTG(portada_url, name, programa_id){ 
        //utilidad para saber los programas que se va creando en cada sede con el fin de llevar control de posibles errores en caso de alguna falla
        let txt = `Nuevo Programa habilitado: <b>${name}</b>`;
        let base = "https://api.telegram.org/bot5407981377:AAF42Y3skFV9YsCXMpXLJ7eVwCjHopQSJ2E/sendPhoto?";
        let chat_id = "-1001783499111";
        let image = this.location_programa_portadas+portada_url;
        let parsemode = "HTML";
        let url = `${base}chat_id=${chat_id}&photo=${image}&caption=${txt}&parse_mode=${parsemode}`

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
            window.console.log(data);
        });

        const u = this.$store.state.CARGO.sede.unidad_negocio;
        if( u != 4 ){ // CAS
          informar(image,name,u,programa_id);
        }
      },
      //llamado al seleccionar un proyecto
      asignarprogramaunsxx(proy) {
        this.proyectosxx = proy;
        //window.console.log('Proyecto seleccionado: ', this.proyectosxx);
      },
      asignarprogramaunsxx2(idprograma) {
        const vue = this;
        vue.loading = true;
        //window.console.log('asignar to db', idprograma);

        let url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/asignarproyecto`;
        //let url = `http://localhost:8090/api/v1/programa-unsxx/asignarproyecto`;

        var data = JSON.stringify({
          id_programa: idprograma,
          id_proyecto: this.proyectosxx.id,
        });

        var config = {
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/json',
          },
          data: data,
        };

        xaxios.request(config)
          .then(function (response) {
            window.console.log(JSON.stringify(response.data));
            let proy = vue.proyectosxx.text;
            vue.msg = `Programa registrado exitosamente (${idprograma}), proyecto asignado: ${proy}`;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.msg = `Programa registrado exitosamente (${idprograma}), no se pudo asignar el proyecto`;
          });
      },
      getproyectoasignado(idprograma) {
        this.loadingproy = true;
        const vue = this;
        let url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/byprograma/${idprograma}`;
        //let url = `http://localhost:8090/api/v1/programa-unsxx/byprograma/${idprograma}`;

        var config = {
          method: 'get',
          url: url,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data;
            vue.proyectoasig = data;
            //window.console.log(data);
            vue.loadingproy = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loadingproy = false;
          });
      },
      guardarcodigoconta() {
        this.msg = '';
        if (!this.codigo_contabilidad) {
          this.msg = 'Debes ingresar un codigo de contabilidad para poder guardarlo.';
          return;
        }
        let cargoid = -1;
        try {
          cargoid = this.$store.state.CARGO.cargo.id;
        } catch (e) {
          window.console.error(e);
        }

        if (cargoid != 15 && cargoid != 25 && cargoid != 1 && cargoid != 14) {
          let men = { title: 'Acceso Denegado.', body: 'Usted no tiene permiso para guardar el codigo.' };
          this.$dialog
            .alert(men)
            .then(function () {})
            .catch(function () {});
          return;
        }

        const vue = this;
        const opt = {
          okText: 'Continuar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        const message2 = {
          title: 'Confirmar guardado del codigo.',
          body: 'El codigo sera guardado, puede editarlo mas tarde',
        };
        this.$dialog
          .confirm(message2, opt)
          .then(function (dialog) {
            vue.guardarcodigoconta2(dialog);
            //dialog.close();
          })
          .catch(function () {});
      },
      guardarcodigoconta2(dialog) {
        /*var myHeaders = new Headers();
            let accessToken = window.localStorage.getItem( "TOKEN" );
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", 'Bearer '+accessToken);*/
        let myHeaders = getheadersrest();
        var raw = JSON.stringify({ programa_id: this.programa.programa_id, codigo: '' + this.codigo_contabilidad });
        var requestOptions = { method: 'POST', headers: myHeaders, body: raw, redirect: 'follow' };

        fetch(process.env.VUE_APP_API_REST + '/api/esam/programa/codigo/insertar', requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.error) {
              let men = { title: 'MENSAJE', body: result.error + '<br/>' };
              this.$dialog
                .alert(men)
                .then(function () {})
                .catch(function () {});
            } else {
              let men = { title: 'GUARDADO', body: 'El codigo de contabilidad ha sido guardado.<br/>' };
              this.$dialog
                .alert(men)
                .then(function () {})
                .catch(function () {});
            }
            dialog.close();
          })
          .catch(() => {
            dialog.close();
          });
      },

      openModalNetsuiteConta(){
        if(!this.programa.planes){
          this.$root.$notify.show(`Este programa no tiene planes de cobro`, {color:'error',x: 'right',});
          return;
        }
        let planes = [...this.programa.planes];
        // con el mayor numero de conscepts sale primero
        planes = planes.sort((a, b) => (b.cobros.length > a.cobros.length) ? 1 : -1);
        let elegido = planes[0];
        // window.console.log( 'this.programa:::',elegido );
        let suc = this.sucursales.find(s=>s.id == this.programa.sucursal_id);
        this.$refs.refNetSuiteConta.open(elegido,this.programa, suc, this.yaenviado);
      },

      aprobarplan(plan) {
        let cargoid = -1;
        try {
          cargoid = this.$store.state.CARGO.cargo.id;
        } catch (e) {
          window.console.error(e);
        }
        if (cargoid != 15 && cargoid != 25 && cargoid != 1 && cargoid != 14) {
          let men = { title: 'Acceso Denegado.', body: 'Usted no tiene permiso para aprobar los planes.' };
          this.$dialog
            .alert(men)
            .then(function () {})
            .catch(function () {});
          return;
        }

        const vue = this;
        const opt = {
          verification: 'aprobar',
          verificationHelp: 'Escriba "[+:verification]" para aprobar el plan de pago.',
          okText: 'Aprobar plan',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        const message2 = {
          title: 'Confirmar aprobacion del plan: ' + plan.nombre + '.',
          body: '<br> <b>NOTA:</b> Esta accion aprobara el plan de pagos, si no esta seguro de esta accion presione el boton cancelar.',
        };
        this.$dialog
          .confirm(message2, opt)
          .then(function (dialog) {
            vue.aprobarplan2(dialog, plan);
          })
          .catch(function () {});
      },
      aprobarplan2(dialog, plan) {
        let userid = this.$store.state.DATA_USER.id;
        let myHeaders = getheadersrest();
        var raw = JSON.stringify({
          programa_id: this.programa.programa_id,
          plan_cobro_id: plan.plan_cobro_programa_id,
          user_id: userid,
        });
        var requestOptions = { method: 'POST', headers: myHeaders, body: raw };

        fetch(process.env.VUE_APP_API_REST + '/api/esam/programa/plan/aprobar', requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.error) {
              let men = { title: 'MENSAJE', body: result.error + '<br/>' };
              this.$dialog
                .alert(men)
                .then(function () {})
                .catch(function () {});
            } else {
              let men = { title: 'APROBADO', body: 'El plan ha sido aprobado<br/>' };
              this.$dialog
                .alert(men)
                .then(function () {})
                .catch(function () {});
              plan.aprobado = true;
            }
            dialog.close();
          })
          .catch(() => {
            dialog.close();
          });
      },
      async getConveniosUniversidades() {
        const sql = gql`
          query {
            getInstituciones(estado: true) {
              id
              nombre
              tipo
              convenio
              abreviatura
            }
          }
        `;
        const data =  await this.$apollo.query({ query: sql }).then(({ data }) => data );
        let conves = data.getInstituciones;
        conves = conves.filter((x) => {
          return x.convenio;
        });
        this.convenios = conves;
        if (this.$refs.amodalconvenio) {
          this.$refs.amodalconvenio.setUniversidades(conves);
        }
      },
      openeditmod(mod) { 
        let idmod = mod.modulo_id;
        let nombre = mod.nombre;
        let numero = mod.numero;
        let programa_modulo_id = mod.programa_modulo_id;
        this.$router.push(
          `/modulo_edit?modulo_id=${idmod}&nombre=${nombre}&numero=${numero}&programa_modulo_id=${programa_modulo_id}`,
        );
      },
      redondearTwoDecimals(cuota, attr) {
        let incluye = (cuota[attr] + '').includes('.');
        let termina = (cuota[attr] + '').endsWith('.');
        window.console.log('cuota', cuota, incluye, termina);
        if (incluye && !termina) cuota[attr] = Math.round((cuota[attr] + Number.EPSILON) * 100) / 100;
      },
      async obtenerProgramasUniversidades() {
        const params = {
          universidadId: this.programaSeleccionado?.universidadId,
          busqueda: this.busqueda || null,
        };

        try {
          const { data } = await ProgramaUniversidadService.findAllPorUniversidadIdBusqueda({ params });

          this.programasUniversidades = data?.datos || [];
        } catch (error) {
          const { mensaje } = error?.response?.data;

          window.console.log(error);

          this.programasUniversidades = [];
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: mensaje || 'Error al listar',
            type: 'error',
          });
        }
      },
      async obtenerPrograma(programaId) {
        try {
          const { data } = await ProgramaService.findOne(programaId);
          const { datos } = data;
          
          this.programaSeleccionado = datos;
        } catch (error) {
          const { mensaje } = error?.response?.data;

          window.console.log(error);

          this.programaSeleccionado = {
            universidadId: null,
            programaUniversidadId: null,
            programaUniversidad : null,
          };
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: mensaje || 'Error al listar',
            type: 'error',
          });
        }
      },
      async actualizarPrograma() {
        if(!this.programaSeleccionado) {
          return;
        }

        const programa = this.programaSeleccionado;
        const { id: programaId } = programa;

        this.actualizandoPrograma = true;

        try {
          const { data } = await ProgramaService.update(programaId, {
            programaUniversidadId: programa.programaUniversidadId
          });
          const mensaje = data?.mensaje;

          this.$refs.confirmacionRef.cerrar();
          this.obtenerPrograma(programaId);
          this.visibleDialogo = false;
          this.$notify({
            group: 'notifications',
            title: 'Éxito',
            text: mensaje || 'Programa actualizado',
            type: 'success',
          });
        } catch (error) {
          const mensaje = error?.response?.data?.mensaje;

          window.console.log(error);

          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: mensaje || 'Error al actualizar',
            type: 'error',
          });
        } finally {
          this.actualizandoPrograma = false;
        }
      },
      mostrarDialogo() {
        if(this.programaSeleccionado) {
          this.programaSeleccionado.universidadId = this.programaSeleccionado.programaUniversidad
                              ? this.programaSeleccionado.programaUniversidad.sedeUniversidad?.universidadId
                              : this.programaSeleccionado?.universidadId;
          
          this.obtenerProgramasUniversidades().then(() => {
            this.visibleDialogo = true;
          });
        }
      },
      cambiarUniversidad() {
        this.programaSeleccionado = {
          universidadId: null,
          programaUniversidadId: null,
          programaUniversidad : null,
        };
        this.obtenerProgramasUniversidades();
      },
      busquedaProgramaUniversidad(search, loading) {
        clearTimeout(this.retardo);

        this.busqueda = search;
        
        this.retardo = setTimeout(() => {
          loading(true);
          this.obtenerProgramasUniversidades().finally(() => loading(false));
        }, 500);
      },
      cerrarDialogo() {
        this.obtenerPrograma(this.programaSeleccionado.id);
        this.visibleDialogo = false;
      },
      async verificarYaenviado(programa_id){
        this.yaenviado = []; 
        this.yaenviado_loading = true;
        let url = `${process.env.VUE_APP_API_REST}/api/esam/programa/netsuite/${programa_id}`;
        let res = await xaxios.get(url).then(({data})=>data).catch(e=>e);
        window.console.log('RESSSS enviado', res);
        if(!res) res = [];
        this.yaenviado = res;
        this.yaenviado_loading = false;
      },
    },
    beforeDestroy(){
      this.$store.state.show_rol_select = true
    },
    async mounted() {
      this.$store.state.show_rol_select = false
      this.modulos_obligatorios = false;
      this.getConveniosUniversidades();
      await this.getSedes();
      let apidev = process.env.VUE_APP_GRAPHQL;
      if (apidev.includes('apidev')) {
        this.isdevmode = true;
      } else {
        this.isdevmode = false;
      }
      this.ispostgrado = true;
      let idrol = this.$store.state.CARGO.id; 
      this.only_read_acade = idrol != 5 && idrol != 6 && idrol != 7 && idrol != 8 && idrol != 1;
      this.only_read_conta = idrol != 14 && idrol != 15 && idrol != 1;
      this.is_perm_benefi = idrol == 8 || idrol == 6 || idrol == 1 || idrol == 14;

      this.getconceptosdepago(); 

      let idprograma = window.localStorage.getItem('rest_idprograma');
      let xpostgrado = window.sessionStorage.getItem('xpostgradorest');
      if (idprograma) {
        this.verificarYaenviado(idprograma);
        this.getprogramabyid(idprograma);
        this.getpostitulos(idprograma);
        this.planesPordefecto();
      } else if (!xpostgrado) {
        let men = {
          title: 'ALERTA:',
          body: 'No se pudo obtener un identificador del programa, vuelva a ingresar a esta pagina.',
        };
        this.$dialog
          .alert(men)
          .then(function () {})
          .catch(function () {});
      } else {
        this.getsucs();
        let post = JSON.parse(xpostgrado);
        //window.console.log('post> ', post);
        if (post.categoria.id == 1 || post.categoria.id == 2 || post.categoria.id == 3) {
          this.modulos_obligatorios = true;
        }
        // window.console.log('possss', post);
        this.xposgradin = post
        
        this.verificarYaenviado(post.id);
        this.programa = {
          nombre_compuesto: post.nombre,
          posgrado_id: post.id,
          nota_aprobacion: 71,
          version: 1,
          grupo: 1,
          gestion: new Date().getFullYear(),
          coordinador: {},
          responsable: {},
          programa_modulo: [],
          planes: [],
          xcategoria_id: post.categoria.id,
        };
        //window.console.log('> ', this.universidadsel);
        this.universidadsel = this.$store.state.convenio;
        this.planesPordefecto();
      }
    },
  };
</script>

<style scoped>
.programa-page {
  background: #f5f7fb;
  padding-bottom: 48px;
}

.programa-card {
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.programa-body {
  background: #fff;
}

.programa-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  margin: 12px 0 18px;
  background: linear-gradient(135deg, #1e88e5 0%, #5e35b1 100%);
  color: #fff;
}

.hero-kicker {
  margin: 0 0 4px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.85;
}

.hero-title-text {
  margin: 0;
  font-weight: 700;
  color: #fff;
}

.hero-subtitle {
  margin: 4px 0 0;
  opacity: 0.9;
}

.hero-chips {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.section-card {
  background: #ffffff;
  border: 1px solid #e6e9f0;
  border-radius: 12px;
  padding: 14px 14px 6px;
  margin-top: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  background: linear-gradient(90deg, #e3f2fd 0%, #ede7f6 100%);
  color: #1e3a8a;
  font-weight: 600;
}

.section-toggle {
  color: #3949ab;
  font-weight: 600;
}

.section-body {
  padding-top: 10px;
}

.modulo-item-card {
  border-radius: 10px;
  background: linear-gradient(135deg, #f8f9ff 0%, #fafbff 100%);
  border: 2px solid #e8eaf6;
  transition: all 0.3s ease;
  /* overflow: visible !important; */
}

.modulo-item-card:hover {
  border-color: #5e35b1;
  box-shadow: 0 6px 20px rgba(94, 53, 177, 0.15);
  transform: translateY(-2px);
}

/* Estilos para Drag and Drop - Diseño mejorado */
.modulo-item-card {
  cursor: move;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%);
  border-left: 4px solid #5e35b1;
  border-radius: 12px !important;
  overflow: visible !important;
  position: relative;
}

.modulo-item-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #5e35b1 0%, #1e88e5 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.modulo-item-card:hover {
  box-shadow: 0 8px 24px rgba(94, 53, 177, 0.25), 0 4px 12px rgba(30, 136, 229, 0.15);
  transform: translateY(-4px) scale(1.01);
  border-left-color: #1e88e5;
}

.modulo-item-card:hover::before {
  opacity: 1;
}

.modulo-item-card.dragging {
  opacity: 0.6;
  border: 3px dashed #1e88e5;
  background: linear-gradient(145deg, #e3f2fd 0%, #ede7f6 100%);
  box-shadow: 0 12px 40px rgba(30, 136, 229, 0.35);
  transform: scale(1.05) rotate(2deg);
  z-index: 1000;
}

.drag-handle {
  cursor: grab;
  transition: all 0.2s ease;
  padding: 8px;
  border-radius: 8px;
}

.drag-handle:hover {
  background: rgba(94, 53, 177, 0.1);
  transform: scale(1.2);
}

.drag-handle:active {
  cursor: grabbing;
  background: rgba(94, 53, 177, 0.2);
  transform: scale(0.95);
}

/* Asegurar que el selector de módulos aparezca por encima */
.modulo-item-card .v-input,
.modulo-item-card .v-select,
.modulo-item-card .v-autocomplete {
  position: relative;
  z-index: 100;
}

.modulo-item-card .v-menu__content,
.modulo-item-card .v-select__menu-content {
  z-index: 200 !important;
}

/* Estilo personalizado para labels en este componente */
::v-deep .v-input .v-label {
  height: 20px;
  line-height: 20px;
  letter-spacing: normal;
  color: #1e3a8a !important;
}

::v-deep .v-icon.v-icon {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-font-feature-settings: "liga";
    font-feature-settings: "liga";
    font-size: 24px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    -webkit-transition
/* Shorthand property combines four of the transition properties into a single property. */
: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
    transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #1e3a8a !important;
}

::v-deep .theme--dark.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: #1e3a8a;
}
@media (max-width: 960px) {
  .programa-hero {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .programa-body {
    padding: 16px;
  }
}
</style>
